import type { AxiosInstance } from "axios";
import { uuid } from "kdc-shared";

export function assignRequestIdPlugin(header: string | string[] = "X-KSC-Request-Id") {
  function hasRequestHeader(headers: any) {
    if (Array.isArray(header)) {
      for (let i = 0; i < header.length; ++i) {
        if (headers[header[i]!]) {
          return true;
        }
      }
      return false;
    }

    return !!headers[header];
  }

  function getRequestHeader() {
    return Array.isArray(header) ? header[0] : header;
  }

  if (Array.isArray(header) && header.length < 1) {
    throw new Error("Please make sure there is one valid header at least");
  }

  return function realAssignRequestIdPlugin(axios: AxiosInstance) {
    axios.interceptors.request.use(
      c => {
        const headers = c.headers ?? {};

        if (!hasRequestHeader(headers)) {
          headers[getRequestHeader()!] = uuid();
        }

        c.headers = headers;
        return c;
      },
      e => Promise.reject(e),
    );

    return axios;
  };
}
